<template>
<div class="pagewide earnings mtpage">

	<topheader back="/panel">
		<template v-slot:info>
			<span>{{$t('labels.earnings')}}</span>
		</template>
		<template v-slot:right>
			
		</template>

	</topheader>

	<maincontent>
		<template v-slot:content>
            <earnings />
		</template>
	</maincontent>


</div>
</template>

<style lang="sass" scoped>
	

</style>

<script>

import earnings from "@/components/modules/panel/earnings/index.vue"


export default {
	name: 'panel_earnings_page',
	components: {
		earnings
	},

	data : function(){
		return { 
			searchEnabled : false
		}
	},

	computed: {

	},

	methods: {
		
	},

	mounted() {

	}
}
</script>
